(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[87741],{

/***/ 666913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ HtmlRenderer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



const DefaultHtmlStyle = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  h2 {
    font-size: 20px;
  }
  h3 {
    font-size: 16px;
  }
  h4 {
    font-size: 14px;
  }
  h5 {
    font-size: 12px;
  }
  h6 {
    font-size: 10px;
  }

  img {
    max-width: 100%;
    height: auto;
  }
`;
const HtmlRenderer = ({
  content,
  className
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DefaultHtmlStyle, {
  className,
  dangerouslySetInnerHTML: { __html: content }
});




/***/ }),

/***/ 800551:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phongvu/desktop/landing/[id]",
      function () {
        return __webpack_require__(766624);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 766624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ landing_id_; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/head.js
var head = __webpack_require__(979894);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(855271);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/HtmlRenderer/HtmlRenderer.es.js
var HtmlRenderer_es = __webpack_require__(666913);
// EXTERNAL MODULE: ./components/desktop/pages/Landing.tsx
var Landing = __webpack_require__(759135);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var index_es = __webpack_require__(420577);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
;// CONCATENATED MODULE: ./tenants/phongvu/desktop/landing/[id].tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  .elementor-section-wrap {\n    > .elementor-element:first-child {\n      margin-top: 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








const StyledHtmlRenderer = (0,styled_es/* styled */.z)(HtmlRenderer_es/* HtmlRenderer */.V)(_templateObject());
const Post = (param)=>{
    let { post  } = param;
    const { baseDomain , canonicalDomain  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    if (!post) {
        // if there is no post in wordpress
        // render it as the default landing flow
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Landing/* LandingPage */.f, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: post.title.rendered
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://legacy.phongvu.vn/landing/wp-content/plugins/elementor/assets/css/frontend.min.css?ver=2.7.5",
                        type: "text/css",
                        media: "all"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://legacy.phongvu.vn/landing/wp-content/uploads/elementor/css/post-".concat(post.id, ".css"),
                        type: "text/css",
                        media: "all"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "".concat(canonicalDomain || baseDomain, "/landing/").concat(post.id)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHtmlRenderer, {
                content: post.content.rendered
            })
        ]
    });
};
const getLandingServerSideProps = async (context)=>{
    let slug = (context.query.id || "").toString();
    if (slug.endsWith(".html")) {
        slug = slug.substring(0, slug.length - 5);
    }
    try {
        const posts = await getPostsBySlug(slug);
        return {
            props: {
                post: posts && posts[0] || null
            }
        };
    } catch (e) {
        logger.error(e);
        return {
            props: {
                post: null
            }
        };
    }
};
const getServerSideProps = (/* unused pure expression or super */ null && (getLandingServerSideProps));
/* harmony default export */ var _id_ = (Post);

;// CONCATENATED MODULE: ./pages/phongvu/desktop/landing/[id].tsx
// AUTO GENERATED FILE. DO NOT EDIT.

var __N_SSP = true;
/* harmony default export */ var landing_id_ = (_id_);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [41305,90400,29078,66756,88837,22859,48530,93712,49774,92888,40179], function() { return __webpack_exec__(800551); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);